import PropTypes from 'prop-types';
function TeacherStatsHeader({ isTeacher, teacherPossessiveScreenName }) {
    let headerText = isTeacher ? 'Celebrating you!' : `Check out ${teacherPossessiveScreenName} accomplishments!`;


        return (
            <header>
                <div className='confetti-container'>
                    <img src='../../../images/teacher/stats/confetti_top.svg'/>
                </div>
                <h1>{headerText}</h1>
            </header>
        );
}

TeacherStatsHeader.propTypes = {
    isTeacher: PropTypes.bool,
    teacherPossessiveScreenName: PropTypes.string,
};

export default TeacherStatsHeader;
